import PRIVACY from './privacy'
import COOKIE from './cookie'
import HR_PRIVACY from './hrPrivacy'
import DPA from './dpa'
import CCTV from './cctv'
import RECRUITMENT_PRIVACY from './recruitmentPrivacy'
import VENDOR from './vendorPrivacy'

const DATA_LIST = [
  PRIVACY,
  HR_PRIVACY,
  COOKIE,
  CCTV,
  RECRUITMENT_PRIVACY,
  VENDOR,
  DPA,
]

export { PRIVACY, HR_PRIVACY, COOKIE, CCTV, RECRUITMENT_PRIVACY, VENDOR, DPA }

export default DATA_LIST
